import { connect, MapStateToProps } from "react-redux";

import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { MessageWindowComponent, MessageWindowComponentProps } from "../MessageWindowComponent";

type StateProps = Pick<MessageWindowComponentProps, "primaryButtonText" | "secondaryButtonText">;
export type MessageWindowProps = {
    /** lokalizační klíč pro text předávaný primary button */
    readonly primaryButtonLocKey: string;
    /** lokalizační klíč pro text předáváný secondary button */
    readonly secondaryButtonLocKey?: string;
};

const mapStateToProps: MapStateToProps<StateProps, MessageWindowProps, IAppState> = (state, { primaryButtonLocKey, secondaryButtonLocKey }) => ({
    primaryButtonText: getPrimaryText(state, primaryButtonLocKey) ?? "",
    secondaryButtonText: secondaryButtonLocKey ? getPrimaryText(state, secondaryButtonLocKey) : undefined,
});

export const MessageWindow = connect(mapStateToProps)(MessageWindowComponent);
